import { Environment } from "../../../environment";
import { Api, IPaginacao } from "../axios-config";

//dados get
export interface IPerfil {
    idPerfil: number,
    nomePerfil: string,
    abrir: boolean,
    alterar: boolean,
    excluir: boolean,
    mesclar: boolean,
    indexar: boolean,
    // consultarDesativado: boolean,
    cnpj: string,
}

interface TPerfil {
    perfis: IPerfil[];
    paginacao: IPaginacao;
}

const getAllByCnpj = async (cnpj: string, page = 1, estado: boolean): Promise<TPerfil | Error> => {
    try {
        const { data } = await Api.get(`/Perfil/cnpj?cnpj=${cnpj}&estado=${estado}&PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const toggleEnabledById = async (idPerfil: number): Promise<void | Error> => {
    try {
        await Api.patch(`Perfil/alterarEstado?id=${idPerfil}`);
    } catch (error) {
        console.error(error);

        return new Error((error as { message: string }).message || 'Erro ao habilitar/desabilitar o registro');
    }
};


const create = async (dados: Omit<IPerfil, 'idPerfil'>): Promise<number | Error> => {
    try {
        const { data } = await Api.post<IPerfil>('/Perfil', dados);

        if (data) {
            return data.idPerfil;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const getById = async (idPerfil: number): Promise<IPerfil | Error> => {
    try {
        const { data } = await Api.get(`Perfil/id?id=${idPerfil}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
};

const updateById = async (dados: IPerfil): Promise<void | Error> => {
    try {
        await Api.put(`Perfil`, dados);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
    }
};


export const PerfilService = {
    getAllByCnpj,
    toggleEnabledById,
    create,
    getById,
    updateById,
}